import { Typography, Grid } from '@pitchero/react-ui';
import React from 'react';
import { Trans } from '../../lib/i18n';

const ruleKeys = ['ruleA', 'ruleB', 'ruleC', 'ruleD', 'ruleE', 'ruleF', 'ruleG', 'ruleH'];
const LotteryRules = () => (
  <>
    <Typography
      style={{
        paddingTop: 15,
        paddingBottom: 15,
        color: '#0B375D',
        fontSize: 24,
        fontWeight: 'bold',
      }}
    >
      <strong>
        <Trans i18nKey="fundraisingClub:rules" />
      </strong>
    </Typography>

    <Grid
      style={{
        listStylePosition: 'outside',
        marginTop: 10,
        padding: 0,
      }}
    >
      {[...Array(8)].map((_, i) => (
        /* can not use i for the key (??) as we get a lint error, no key we get no lint error but a console error */
        <li key={ruleKeys[i]}>
          <Trans i18nKey={`fundraisingClub:rule_${i}`} />
        </li>
      ))}
    </Grid>

    <Typography
      component="p"
      preset="body--large"
      color="black"
      className="bbcode-content"
      style={{ marginTop: 20 }}
    />
  </>
);

LotteryRules.propTypes = {};

export default LotteryRules;
